import React, { forwardRef } from 'react';
import styled from 'styled-components';
import {
  Popover as HeadlessPopover,
  PopoverButton as HeadlessPopoverButton,
  PopoverPanel as HeadlessPopoverPanel,
} from '@headlessui/react';

import { popoverPanelStyles, popoverPanelFocusOverrides } from './shared';

export const PopoverButton = HeadlessPopoverButton;

const StyledPopoverPanel = styled(HeadlessPopoverPanel)<{ $width?: string }>`
  ${popoverPanelStyles}
  width: ${({ $width }) => $width || 'auto'};
  padding: 4px;
  ${popoverPanelFocusOverrides}
`;

export type DesignSystemPopoverPanelProps = React.ComponentProps<typeof HeadlessPopoverPanel> & {
  width?: string;
};

export const PopoverPanel = forwardRef<HTMLDivElement, DesignSystemPopoverPanelProps>(
  ({ children, width, transition = true, ...rest }, ref) => (
    <StyledPopoverPanel ref={ref} $width={width} transition={transition} {...rest}>
      {children}
    </StyledPopoverPanel>
  ),
);

PopoverPanel.displayName = 'PopoverPanel';

export type PopoverProps = { children: React.ReactNode } & React.ComponentProps<typeof HeadlessPopover>;

export const Popover = ({ children, ...rest }: PopoverProps) => (
  <HeadlessPopover {...rest}>
    {/* This div ensures Headless UI receives a single child */}
    <div>{children}</div>
  </HeadlessPopover>
);
